module.exports = __webpack_public_path__ + "img/bg-login-page.400ab351.svg";